// Copyright (c) Move Closer 2022.

import {
  AppModule,
  Container,
  EventbusType,
  IConfiguration,
  IEventbus,
  Interfaces,
  IObserver,
  Module,
  WindowType
} from '@movecloser/front-core'

import { GAEventObserverType, GAObserver } from './observers'
import { SiteServiceType } from '../../contexts'

@AppModule({
  name: 'analytics',
  providers: (config: IConfiguration) => (bind: Interfaces.Bind) => {
    bind<IObserver>(GAEventObserverType).toDynamicValue((context) => {
      return new GAObserver(
        config.byFile('analytics') ?? {},
        context.container.get(SiteServiceType),
        context.container.get(WindowType)
      )
    }).inSingletonScope()
  },
  boot: (container: Container) => {
    const eventBus: IEventbus = container.get(EventbusType)
    const GAObserver: IObserver = container.get(GAEventObserverType)

    eventBus.observe(GAObserver)
  }
})
export class AnalyticsModule extends Module {}
